<template>
  <el-row type="flex" align="middle" :gutter="20">
    <el-col :span="16">
      <Chart type="line" :labels="hourLabels" :datasets="datasets" :plugins="plugins"/>
    </el-col>

    <el-col :span="8">
      <el-select v-model="currentSelectValue" :placeholder="$t('text.chooseMerchant')">
        <el-option v-for="option in selectList"
                   :key="option.appId"
                   :label="option.merchantName"
                   :value="option.appId"/>
      </el-select>

      <hr class="my-6"/>

      <el-radio-group v-model="currentRadioValue" size="mini">
        <el-radio-button v-for="radio in radioList"
                         :key="radio.channelId"
                         :label="radio.channelId"
                         class="mb-4 mr-4">
          {{ radio.channelName }}
        </el-radio-button>
      </el-radio-group>
    </el-col>
  </el-row>
</template>

<script>
import Chart from "../../components/chart/Chart.vue";
import ChartMixin from "./mixin/ChartMixin";

export default {
  components: {Chart},
  name: "CreatedByMerchantChart",
  mixins: [ChartMixin],
  watch: {
    currentSelectValue() {
      this.getRadioList("/Chart/selectCreatedChannelList", {
        productId: this.id,
        appId: this.currentSelectValue
      }).then(() => {
        this.currentRadioValue =
            this.radioList.length > 0 ? this.radioList[0].channelId : "";

        this.getChartList({
          appId: this.currentSelectValue,
          channelId: this.currentRadioValue,
          payType: this.id
        });
      });
    },
    currentRadioValue() {
      this.getChartList({
        appId: this.currentSelectValue,
        channelId: this.currentRadioValue,
        payType: this.id
      });
    }
  },
  mounted() {
    this.getSelectList("/Chart/selectMerchantList", {});
  }
};
</script>

<style scoped lang="scss">
.mt-4 {
  margin-top: 1rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mr-4 {
  margin-right: 1rem;
}

.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

::v-deep .el-radio-button {
  .el-radio-button__inner {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }

  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border-color: transparent;
  }
}
</style>
